<template>
    <v-radio-group row mandatory :model-value="selectedMeasurement" class="measurement">
        <v-radio
            v-for="measurement in measurements"
            :key="measurement"
            :value="measurement"
            :disabled="disabled"
            :label="toSentenceCase($t(`${translationPath}.${measurement}`))"
        />
    </v-radio-group>
</template>

<script>
import measurements from '@enums/measurements';

export default {
    props: {
        selectedMeasurement: String,
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            measurements,
            translationPath: 'supplierCommitments.measurements',
        };
    },
};
</script>

<style lang="scss">
.measurement {
    margin-top: 0;
    padding-top: 0;
}
.v-radio .v-selection-control__wrapper .v-icon {
    font-size: 1.5rem !important;
}
</style>
